import { TFunction } from "i18next";

import { IRole } from "interfaces/user.interface";

export const ZoneUserRole = {
  OWNER: "OWNER",
  ADMIN: "ADMIN",
  MANAGER: "MANAGER",
  MANAGER_LIMITED: "MANAGER_LIMITED",
  SERVICE_MONITOR: "SERVICE_MONITOR",
  DATA_READER: "DATA_READER",
  DATA_READER_LIMITED: "DATA_READER_LIMITED",
} as const;

export type IZoneUserRole = (typeof ZoneUserRole)[keyof typeof ZoneUserRole];

export const getOperativeRoles = (t: TFunction): IRole[] => {
  return [
    {
      name: t("role_date_reader_limited"),
      value: ZoneUserRole.DATA_READER_LIMITED,
      activeChipTheme: "neutral",
      tooltip: t("role_date_reader_limited_info"),
      order: 1,
      type: "operative",
    },
    {
      name: t("role_date_reader"),
      value: ZoneUserRole.DATA_READER,
      activeChipTheme: "neutral",
      tooltip: t("role_date_reader_info"),
      order: 2,
      type: "operative",
    },
  ];
};

export const getAdministrativeUserRoles = (t: TFunction): IRole[] => {
  return [
    {
      name: t("role_manager_limited"),
      value: ZoneUserRole.MANAGER_LIMITED,
      activeChipTheme: "neutral",
      tooltip: t("role_manager_limited_info"),
      order: 3,
      type: "administrative",
    },
    {
      name: t("role_manager"),
      value: ZoneUserRole.MANAGER,
      activeChipTheme: "neutral",
      tooltip: t("role_manager_info"),
      order: 4,
      type: "administrative",
    },
    {
      name: t("role_admin"),
      value: ZoneUserRole.ADMIN,
      activeChipTheme: "neutral",
      tooltip: t("role_admin_info"),
      order: 5,
      type: "administrative",
    },
    {
      name: t("role_owner"),
      value: ZoneUserRole.OWNER,
      activeChipTheme: "accent",
      tooltip: t("role_owner_info"),
      order: 6,
      type: "administrative",
    },
  ];
};

export const getServiceRoles = (t: TFunction): IRole[] => {
  return [
    {
      name: t("role_service_account"),
      value: ZoneUserRole.SERVICE_MONITOR,
      activeChipTheme: "neutral",
      tooltip: t("role_service_account_info"),
      order: 7,
      type: "service_monitor",
    },
  ];
};

export const getZoneUserRolesAsEntity = (t: TFunction) =>
  [
    ...getOperativeRoles(t),
    ...getAdministrativeUserRoles(t),
    ...getServiceRoles(t),
  ].reduce<Record<string, IRole>>((result, role) => {
    result[role.value] = role;

    return result;
  }, {});
